/* eslint-disable no-underscore-dangle */
import { Typography } from "@mui/material";
import { Map } from "ol";
import React from "react";
import { useTranslation } from "react-i18next";
import { ProjectShapePlanMapItem } from "../types/mapItems";
import { GenericPopup } from "./GenericPopup";

type ProjectShapePopupProps = { data: ProjectShapePlanMapItem; map: Map };

export const ProjectShapePlanPopup = ({
  data,
  map,
}: ProjectShapePopupProps) => {
  // const { t } = useTranslation();
  const { SubArea } = data;
  const { t } = useTranslation();

  return (
    <GenericPopup
      map={map}
      title={<Typography variant="h6">{t("projects:plan")}</Typography>}
      clicked
      subheader={SubArea}
      headerProps={{
        sx: { paddingBottom: "0px" },
        //   titleTypographyProps: { fontSize: 12 },
      }}
    />
  );
};
